<template>
	<div class="noData" v-if="isShow">
		<img :style="{width: imgWidth + 'px'}" src="@/static/noData.png" @load="handleImageLoad" />
		<span v-if="isDelayShowStr && isShowStr">{{str}}</span>
	</div>
</template>

<script>
	export default {
		name: 'noData',
		props: {
			isShow: {
				type: Boolean,
				default: false
			},

			str: {
				type: String,
				default: '暂无数据'
			},

			imgWidth: {
				type: Number,
				default: 300
			},

			isShowStr: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				isDelayShowStr: false
			}
		},
		methods: {
			handleImageLoad() {
				this.isDelayShowStr = true;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.noData {
		padding: 7vh 0 5vh;
		text-align: center;
		display: flex;
		flex-direction: column;

		img {
			margin: 0 auto;
		}
		
		span {
			margin-top: 15px;
		}
	}
</style>